import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { toast } from 'react-toastify';
import { removeStorageItem } from './utils/storage';
import { isApiError } from '@/types';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes (formerly cacheTime)
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      // Global error handler for all queries
      if (isApiError(error) && error?.status === 401) {
        // Show notification to user
        toast.error('Your session has expired. Please sign in again.', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        // Clear authentication tokens
        removeStorageItem('accessToken');
        removeStorageItem('idToken');
        removeStorageItem('refreshToken');
        removeStorageItem('expiresIn');
        removeStorageItem('landlordId');
        removeStorageItem('landlordInfo');
        
        // Redirect to sign in page after a brief delay
        setTimeout(() => {
          window.location.href = '/signin';
        }, 2000);
      }
    },
  }),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
)
